export const normalizeMediaUrl = (url?: string | null): string => {
  if (!url) return "";

  const value = url.trim();
  const dataIndex = value.indexOf("data:");

  // Fix malformed URLs like: https://domain/uploads/data:image/...;base64,...
  if (dataIndex > 0) {
    return value.slice(dataIndex);
  }

  return value;
};

export const normalizeHtmlMediaSources = (html?: string | null): string => {
  if (!html) return "";

  return html.replace(
    /(src=["'])([^"']+)(["'])/gi,
    (_match, prefix, rawUrl, suffix) => {
      const normalized = normalizeMediaUrl(rawUrl);
      return `${prefix}${normalized}${suffix}`;
    }
  );
};

